import { render } from "./Sidebar.vue?vue&type=template&id=7349c088&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=7349c088&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7349c088"]])

export default __exports__